import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Box } from 'rebass/styled-components';

const Animation = keyframes`
  0% {
    transform: scaleX(0);
    transform-origin: left;
  }
  49% {
    transform: scaleX(1);
    transform-origin: left;
  }
  50% {
    transform: scaleX(1);
    transform-origin: right;
  }
  100% {
    transform: scaleX(0);
    transform-origin: right;
  }
`;

// UI refresh: invisible when idle; a thin accent sweep only while loading.
const Container = styled(Box) <{ loading: boolean }>`
  width: 100%;
  background-color: ${(p) => (p.loading ? 'rgba(229, 5, 106, 0.15)' : 'transparent')};
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
`;

const Loading = styled(Box)`
  width: 100%;
  background-color: ${(p) => p.theme.colors.primary};
  box-sizing: border-box;
  position: absolute;
  animation: ${Animation} 3s infinite;
`;

type Props = {
  loading: boolean;
  height?: string;
};

export const LoadingBar: React.FC<Props> = ({ loading, height = '3px' }) => {
  const h = height === '5px' ? '3px' : height;
  return (
    <Container loading={loading} style={{ height: h }} role={loading ? 'progressbar' : undefined} aria-label={loading ? 'Loading' : undefined}>
      {loading && <Loading style={{ height: h }} />}
    </Container>
  );
};
